import { FORM_BAR_BUTTONS } from 'constants/styles/_types/FormBarButtons';

export const mobileGridTemplateAreas = `
  "${FORM_BAR_BUTTONS.previousButtonArea} ${FORM_BAR_BUTTONS.previousButtonArea}"
  "${FORM_BAR_BUTTONS.nextButtonArea} ${FORM_BAR_BUTTONS.nextButtonArea}"
`;
